/* eslint-disable */
import React, {Component} from 'react';
import './less/detail.less';
import {Divider, Button,} from 'antd';

export default class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    uploadFile() {

    }

    backUp() {
        if (this.props.backUp) {
            this.props.backUp();
        }
    }

    render() {
        const {title, require, feTitle, position, responsibility,} = this.props;

        return (
            <div className={"detail"}>
                <div className="content0">
                    <div className="title-wrapper">
                        <h1 className={"title"}><p>{title}&nbsp;</p></h1>
                        <h2 className={"feTitle"}><p>{feTitle}&nbsp;</p></h2>
                    </div>
                </div>
                <Divider dashed/>
                <div className={"textContent"}>
                    <p>工作地点：{position}</p>
                    <p>岗位职责：</p>
                    {
                        responsibility && responsibility.length > 0 && responsibility.map((text) => {
                            return (
                                <p className={"textP"}>{text}</p>
                            )
                        })
                    }
                    <p style={{marginTop: 15,}}>任职要求：</p>
                    {
                        require && require.length > 0 && require.map((text) => {
                            return (
                                <p className={"textP"}>{text}</p>
                            )
                        })
                    }
                </div>
                <div className={"footer"}>
                    {/*<Button onClick={() => this.uploadFile()} style={{marginRight: 15,}}>上传简历</Button>*/}
                    <Button onClick={() => this.backUp()}>返回</Button>
                </div>
            </div>
        )
    }
}


